import axiosClient from "@/utils/axios-client";

const url = {
  getUserList: () =>
    process.env.NEXT_PUBLIC_API_URL + `/users`,
};

export const authApi = {
  getUserList: (tempToken: string) =>
    axiosClient.get(url.getUserList(),{
      params: {
        temp_token: tempToken,
      },
    }),
};
